var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(false)?_c('v-alert',{attrs:{"dense":"","type":"info"}},[_vm._v(" Dieses Dokument wurde zur löschung vorgemerkt. ")]):_vm._e(),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('DocumentCard')],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('RevisionTable',{attrs:{"type":"FORM"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }